import { colors } from '../../../shared/theme/colors'
import { spacing } from '../../../shared/theme/spacing'
import { typography } from '../../../shared/theme/typography'
import { ticketColors, ticketFonts } from '../../../shared/theme/ticketColors';

export const posCartPromosStyleDefs = {
  cartPromoActionsBar: {
      marginTop: 0,
      marginBottom: 0,
      paddingHorizontal: 12,
    },

  cartPromoCollapsedHeader: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: spacing.sm,
      minHeight: 32,
      marginBottom: 2,
    },

  cartPromoCollapsedBlock: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: spacing.sm,
      minWidth: 0,
    },

  cartPromoCollapsedToggle: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 4,
      flexShrink: 0,
      paddingVertical: 4,
      paddingHorizontal: 2,
    },

  cartPromoCollapsedChips: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: spacing.xs,
      flex: 1,
      minWidth: 0,
    },

  cartPromoExpandLink: {
      ...typography.caption,
      color: colors.textSecondary,
      fontWeight: '700',
      textDecorationLine: 'underline',
    },

  cartPromoCodeRow: {
      flexDirection: 'row',
      alignItems: 'stretch',
      gap: 8,
      marginBottom: 0,
      alignSelf: 'stretch',
      width: '100%',
    },

  cartPromoCodeInput: {
      flex: 1,
      minWidth: 0,
    },

  cartPromoTicketCodeInput: {
      height: 40,
      minHeight: 40,
      borderRadius: 10,
      borderWidth: 1,
      borderColor: ticketColors.ruleSoft,
      backgroundColor: ticketColors.paper2,
      color: ticketColors.ink,
      paddingHorizontal: 12,
      paddingVertical: 0,
      fontSize: 14,
      fontWeight: '500',
      fontFamily: ticketFonts.sans,
    },

  cartPromoErrorText: {
      ...typography.caption,
      color: colors.danger,
      fontWeight: '600',
    },

  cartPromoStaleRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: spacing.xs,
      minWidth: 0,
    },

  cartPromoCashierRow: {
      flexDirection: 'row',
      alignItems: 'center',
      alignSelf: 'stretch',
    },

  cartPromoAppliedChip: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 6,
      alignSelf: 'flex-start',
      maxWidth: '100%',
    },

  cartPromoTicketPanel: {
      marginTop: 8,
      paddingTop: 12,
      borderTopWidth: 1,
      borderTopColor: ticketColors.rule,
      gap: 10,
      alignSelf: 'stretch',
      width: '100%',
    },

  cartPromoTicketHeaderText: {
      flex: 1,
      minWidth: 0,
      flexDirection: 'row',
      alignItems: 'baseline',
      justifyContent: 'space-between',
      gap: spacing.sm,
    },

  cartPromoTicketSectionTitle: {
      color: colors.textMuted,
      fontWeight: '600',
      fontSize: 12,
      letterSpacing: 0.4,
      textTransform: 'uppercase',
      fontFamily: ticketFonts.sans,
    },

  cartPromoTicketHint: {
      color: colors.textMuted,
      fontSize: 11,
      fontWeight: '500',
      fontFamily: ticketFonts.sans,
    },

  cartPromoTicketList: {
      gap: 6,
      minWidth: 0,
    },

  cartPromoTicketItem: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      paddingVertical: 8,
      paddingHorizontal: 10,
      borderRadius: 10,
      backgroundColor: ticketColors.okBg,
      borderWidth: 1,
      borderColor: ticketColors.okBorder,
    },

  cartPromoTicketItemText: {
      flex: 1,
      minWidth: 0,
      gap: 1,
    },

  cartPromoTicketItemTitle: {
      color: colors.textPrimary,
      fontWeight: '500',
      fontSize: 13,
      fontFamily: ticketFonts.sans,
    },

  cartPromoTicketItemSub: {
      color: colors.textMuted,
      fontSize: 11,
      fontWeight: '400',
      fontFamily: ticketFonts.sans,
    },

  cartPromoTicketItemAmt: {
      color: ticketColors.ok,
      fontWeight: '600',
      fontSize: 12,
      fontVariant: ['tabular-nums'],
      fontFamily: ticketFonts.mono,
    },

  cartPromoTicketItemRemove: {
      width: 28,
      height: 28,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 8,
    },

  cartPromoApplyBtn: {
      height: 40,
      minHeight: 40,
      borderRadius: 10,
      paddingHorizontal: 14,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: ticketColors.brandSoft,
      borderWidth: 0,
      flexShrink: 0,
      alignSelf: 'stretch',
    },

  cartPromoApplyBtnText: {
      color: ticketColors.brandInk,
      fontWeight: '600',
      fontSize: 13,
      lineHeight: 16,
      fontFamily: ticketFonts.sans,
    },

  cartPromoCashierLink: {
      flex: 1,
      alignSelf: 'stretch',
      borderWidth: 1,
      borderStyle: 'dashed',
      borderColor: ticketColors.ruleSoft,
      borderRadius: 10,
      paddingVertical: 10,
      paddingHorizontal: 12,
      backgroundColor: 'transparent',
    },

  cartPromoCashierLinkText: {
      color: colors.textSecondary,
      fontWeight: '500',
      fontSize: 13,
      fontFamily: ticketFonts.sans,
      textAlign: 'left',
    },

  cartPromoInactiveHint: {
      color: colors.textMuted,
      fontWeight: '400',
      fontSize: 11,
      fontFamily: ticketFonts.sans,
      textAlign: 'left',
      marginTop: 4,
    },

  cartPromoClearLink: {
      alignSelf: 'flex-start',
    },

  cartPromoClearLinkText: {
      ...typography.caption,
      color: colors.textSecondary,
      fontWeight: '600',
      textDecorationLine: 'underline',
    },

  cartPromoSummaryBlock: {
      gap: spacing.xs,
      paddingHorizontal: spacing.sm,
    },

  cartPromoSummaryBlockCompact: {
      paddingHorizontal: spacing.xs,
      gap: 2,
    },
} as const;
